import {EndPoints} from '../api-config';
let SERVER_ADDR_V1 = EndPoints.backendHost;


export const userRepresentativeSelfcareLinkByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/selfcare/${id}/link`;
export const userRepresentativeSelfcareAuthByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/selfcare/${id}/auth`;
export const userRepresentativeByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/selfcare/${id}`;